import { IOptionValue } from "shared/interfaces/Catalog.interface";
import { IOrderItem } from "shared/interfaces/Order.interface";

export default (
  currentDish: IOrderItem,
  currentValue: IOptionValue
): IOrderItem | undefined =>
  currentDish.modifiers.find((modifier) => currentValue.id === modifier.id);
